/* tjs <- hot-reload.ts */

/*#
# hotReload

`hotReload()` persists any root-level paths in `xin` that its test function evaluates as true
to `localStorage`.

```
hotReload(test: PathTestFunction = () => true): void
```
*/

import { xin, observe } from './xin'

import { tosiValue } from './metadata'

import { XinObject, PathTestFunction, ObserverCallbackFunction } from './xin-types'

import { debounce } from './throttle'

/* line 23 */
export function hotReload(test = () => true) {
    const savedState = localStorage.getItem('xin-state');
    if (savedState != null) {
        const state = JSON.parse(savedState);
        for (const key of Object.keys(state).filter(test)) {
            if (xin[key] !== undefined) {
                Object.assign(xin[key], state[key]);
            }
            else {
                xin[key] = state[key];
            }
        }
    }
    const saveState = debounce(() => {
        const obj = {};
        const state = tosiValue(xin);
        for (const key of Object.keys(state).filter(test)) {
            obj[key] = state[key];
        }
        localStorage.setItem('xin-state', JSON.stringify(obj));
        console.log('xin state saved to localStorage');
    }, 500);
    observe(test, saveState);
}
hotReload.__tjs = {
  "params": {
    "test": {
      "type": {
        "kind": "function"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "hot-reload.ts:23"
}